<template>
  <div class="categoryDetails">
    <i
      v-if="category.children"
      class="material-icons action-icon"
      @click="toggleSubcategoryVisibility(!category.showChildren)"
    >
      {{ category.showChildren ? "keyboard_arrow_down" : "keyboard_arrow_right" }}
    </i>
    <!-- FIXME - Pass this with params and a prettier hash -->
    <router-link v-if="directLink" :to="'/category/' + category.id">
      {{ category.name }}
    </router-link>
    <a v-else>
      {{ category.name }}
    </a>
    <template v-if="showStats && !isMobile()">
      <br />
      <edit-category-trigger v-if="showEditTrigger" :categoryId="category.id" class="editIcon" />
      <span class="categoryStats">
        {{ completed }}
        /
        {{ quota }}
      </span>
    </template>
  </div>
</template>

<script>
import EditCategoryTrigger from "./EditCategoryTrigger.vue";

import db from "../db.js";
import util from "../util.js";

export default {
  name: "category-details-block",
  mixins: [util.getMobileMixin()],
  components: {
    "edit-category-trigger": EditCategoryTrigger,
  },
  props: {
    category: Object,
    // FIXME - Better names for completed and quota since we are using them for multiple values
    completed: [String, Number],
    quota: [String, Number],
    directLink: {
      type: Boolean,
      default: false,
    },
    showEditTrigger: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleSubcategoryVisibility(isVisible) {
      db.setSubcategoryVisibility(this.category.id, isVisible);
    },
  },
  computed: {
    showStats() {
      return typeof this.completed != "undefined" && typeof this.quota != "undefined";
    },
  },
};
</script>

<style>
.categoryDetails {
  width: 150px;
  text-align: right;
  border-right: 1px solid #eee;
  padding-right: 0.75rem;
}

.categoryDetails .action-icon {
  font-size: 1.25rem;
  position: relative;
  top: 0.3rem;
}

.categoryDetails a {
  color: #2c3e50;
  text-decoration: none;
  cursor: default;
  /*cursor: pointer; FIXME - TURN ME BACK ON AFTER WE TURN BACK ON CATEGORY LINKS*/
}

.categoryStats {
  font-size: 0.875rem;
  margin-right: 0.375rem;
}

.editIcon.material-icons.action-icon {
  margin: 0;
}

@media (max-width: 600px) {
  .categoryDetails {
    text-align: left;
    width: auto;
    margin-left: 0.5rem;
    border-right: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// CategoryDetailsBlock.vue?04874a0b